import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AnalyticEvents } from '@app/enums';
import { EmployeeFeedbackTable } from '@app/modules/employees/services/tables/feedback/employee-feedback.table';
import { EmployeeGoalsTable } from '@app/modules/employees/services/tables/goals/employee-goals.table';
import { EmployeeReviewsTable } from '@app/modules/employees/services/tables/reviews/employee-reviews.table';
import { AnalyticService } from '@app/services';
import { AuthService } from '@app/services/auth.service';
import { NotifyService } from '@app/services/notify.service';
import { IndexView } from '@common/views';
import { BaseForm } from '@forms/base.form';
import { Employee } from '@models/employee/employee.model';
import { Feedback } from '@models/performance/feedback.model';
import { Goal } from '@models/performance/goal.model';
import { Review } from '@models/performance/review.model';
import { Status } from '@performance/enums/status.enum';

@Component({
    templateUrl: './performance-index.template.html',
    styleUrls: ['./performance-index.style.scss'],
})
export class PerformanceIndexView extends IndexView implements OnInit {
    isLoading = true;
    employee: Employee;

    // Class access for permissions
    viewReviewsPermission = Review.permission.view;
    viewGoalsPermission = Goal.permission.view;
    viewFeedbackPermission = Feedback.permission.view;

    createReviewPermission = Review.permission.edit;
    createGoalPermission = Goal.permission.edit;
    createFeedbackPermission = Feedback.permission.edit;

    canOpenMoreActionsMenu = false;

    Status = Status;
    reviewsTable: EmployeeReviewsTable;
    feedbackTable: EmployeeFeedbackTable;
    goalsTable: EmployeeGoalsTable;

    constructor(
        private route: ActivatedRoute,
        protected auth: AuthService,
        private notify: NotifyService,
        private analyticService: AnalyticService
    ) {
        super();

        this.employee = this.route.snapshot.data.models.get('employee');
        if (this.auth.can(this.viewReviewsPermission)) {
            this.reviewsTable = new EmployeeReviewsTable(this.auth, this.employee);
        }
        if (this.auth.can(this.viewGoalsPermission)) {
            this.goalsTable = new EmployeeGoalsTable(this.auth, this.employee);
        }
        if (this.auth.can(this.viewFeedbackPermission)) {
            this.feedbackTable = new EmployeeFeedbackTable(this.auth, this.employee);
        }

        this.canOpenMoreActionsMenu = [this.createGoalPermission, this.createFeedbackPermission].some((p) =>
            this.auth.can(p)
        );
    }

    ngOnInit(): void {
        this.isLoading = false;
    }

    onCreate(): void {
        // Not implemented
    }

    createFeedback(feedback: Feedback, form: BaseForm): void {
        feedback.subjectId = feedback.subjectId || this.employee.id;
        feedback
            .save()
            .then(() => {
                form.reset();
                this.feedbackTable.reload();
                this.analyticService.trackEvent(AnalyticEvents.PerformanceCreatingFeedbackAllSave);
            })
            .catch(() => this.notify.error('performance.feedback-index.couldNotCreate'));
    }

    onDelete(): void {
        // Not Implemented
    }

    trackCreatingReview(): void {
        this.analyticService.trackEvent(AnalyticEvents.EmployeeProfilePerformanceClickCreateReview);
    }

    trackCreatingFeedback(): void {
        this.analyticService.trackEvent(AnalyticEvents.EmployeeProfilePerformanceClickCreateFeedback);
    }

    trackCreatingGoal(): void {
        this.analyticService.trackEvent(AnalyticEvents.EmployeeProfilePerformanceClickCreateGoal);
    }
}
